import React, { useState, useEffect, useContext } from "react";

import Gender from "./components/Gender";
import ProgressBar from "./components/ProgressBar";
import Birthday from "./components/Birthday";
import Name from "./components/Name";
import Email from "./components/Email";
import Password from "./components/Password";
import Result from "./components/Result";
import CookieBanner from "./components/CookieBanner";

import { getTTI, sendScreenResolution, simplyClick } from "./helpers";
import { events, landingId } from "./constants";
import { createPortal } from "react-dom";
import { useAppendLandingId } from "./hooks/useAppendLandingId";
import { ContextProfileUser } from "./lib/profileContext";
import { useSessionData } from "ui-components";

function App() {

  const [step, setStep] = useState(1);
  const cookieBannerBlock = document.getElementById("cookie__banner");
  useAppendLandingId(landingId);

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent?.trim() ?? "";
    let previousText = initText;

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim() ?? "";
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "footer_links",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    if (window.location.search !== "") {
      const signInButton = document.querySelector(".login");
      signInButton?.setAttribute("href", `/login/${window.location.search}`);
    }

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const loginButton = document.querySelector(".login");

    const clickHandler = () => {
      simplyClick(events[step]);
    };

    loginButton.addEventListener("click", clickHandler);

    return () => {
      loginButton.removeEventListener("click", clickHandler);
    };
  }, [step]);

  const renderContent = () => {
    switch (step) {
      case 1:
        return <Gender setStep={setStep} step={step} />;
      case 2:
        return <Birthday setStep={setStep} step={step} />;
      case 3:
        return <Name setStep={setStep} step={step} />;
      case 4:
        return <Email setStep={setStep} step={step} />;
      case 5:
        return <Password setStep={setStep} step={step} />;
      case 6:
        return <Result />;
      default:
        return null;
    }
  };

  return (
    <>
      <ProgressBar step={step} />
      {renderContent()}

      {createPortal(<CookieBanner />, cookieBannerBlock)}
    </>
  );
}

export default App;
